import { s } from "./chunks/runtime.js";
import { g as P } from "./chunks/runtime.js";
/*! All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
v3.0.3 */
let e = !1;
const o = (t) => {
  e = !0, s(t);
};
export {
  e as assetPathChanged,
  P as getAssetPath,
  o as setAssetPath
};
